import { IconProps } from '@ui-system/interfaces-icon';

const defaultProps: Partial<IconProps> = {
  color: 'secondary',
};

export default defaultProps;
